module.exports = __webpack_public_path__ + "img/wechat_auth.e7f9a2ec.png";